import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    const blocks = document.querySelectorAll('[block-cta-button], [block-faq]')
    blocks.forEach((block) => {
      this.el.appendChild(block)
      block.classList.add('lg:col-start-1')
      block.classList.add('lg:col-end-3')
      block.classList.remove('hidden')
    })
  }
}
